import { TopicApi } from "@/api";

export async function get(id) {
  const { data } = await TopicApi.get(id);
  return data;
}
